import { IBeekeeperUserQuery } from '../interfaces/beekeeper-user.interface';

export class BeekeeperUser {
    beekeeperUsername: string;
    beekeeperId: string;

    constructor(query: IBeekeeperUserQuery) {
        this.beekeeperUsername = query.beekeeper_username;
        this.beekeeperId = query.beekeeper_id;
    }
}
